import { isUUID } from '../utils/validations'

export const messages = {
  noItems: {
    message:
      'Select Add New Assignments button to configure positions and locations for this form.',
    title: 'No Assignments Added'
  },
  noMatch: {
    message: '',
    title: 'No results to display'
  }
}

export const sortKeys = {
  position: 'positionName',
  location: 'locationName',
  'location number': 'locationNumber',
  state: 'locationStateProvince',
  brand: 'brandName'
}

export function createAssignmentId(assignment) {
  return `${assignment.locationId}_${assignment.positionId}`
}

export function formatAssignments(ass) {
  return ass.map((x) => ({
    id: createAssignmentId(x),
    location: x.locationName,
    locationId: x.locationId,
    'location number': x.locationNumber,
    locationCity: x.locationCity,
    'state/prov': x.locationStateProvince,
    brand: x.brandName ? x.brandName.join(', ') : x.brandName,
    position: x.positionName,
    positionId: x.positionId
  }))
}

export function getKey(dataKey) {
  return Object.keys(sortKeys).find((x) => sortKeys[x] === dataKey)
}

export function getNewAssignments(newItems = [], currentItems = []) {
  return newItems.filter((x) => currentItems.every((y) => y.id !== createAssignmentId(x)))
}

export function getUrl({
  action,
  filter,
  formId,
  pageSize,
  pageNum,
  orderBy,
  ascending,
  searchText,
  totalCount,
  versionId
}) {
  const versionStr = isUUID(formId) && versionId ? `/version/${versionId}` : ''

  const baseUrl =
    `/forms/${formId}` +
    `${versionStr}` +
    '/assignments' +
    `?asc=${ascending}` +
    `&orderBy=${orderBy}`

  // for downloadCsv & selectAll, set pageSize to totalCount and pageNumber to 1
  const loadAllItems = ['downloadCsv', 'selectAll']
  const pageNumSize = !loadAllItems.includes(action)
    ? `&pageSize=${pageSize}&pageNumber=${pageNum}`
    : `&pageSize=${totalCount}&pageNumber=1`

  // do not add searchText param if no text is here
  const searchQuery =
    searchText !== null && searchText.length > 0
      ? `&searchText=${encodeURIComponent(searchText)}`
      : ''

  const stateFilter =
    filter.state !== null ? `&locationState=${encodeURIComponent(filter.state)}` : ''
  const brandFilter = filter.brand !== null ? `&brandName=${encodeURIComponent(filter.brand)}` : ''

  return baseUrl + pageNumSize + searchQuery + stateFilter + brandFilter
}

export function processSelections(list, id) {
  return list.includes(id) ? list.filter((x) => x !== id) : [...list, id]
}



// WEBPACK FOOTER //
// ./src/modules/Forms/reducers/assign-helpers.js